export default "<nav class=\"page-navigation\">\n  <ng-content></ng-content>\n</nav>\n"